export default "__VITE_ASSET__C35LCCc3__"